import React, { useMemo } from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'

interface Props {
  offer: App.CarHireOffer;
  onViewInclusions: () => void;
}

function CarHireOfferTileInclusions(props: Props) {
  const { offer, onViewInclusions } = props

  const inclusionsList = useMemo(() => {
    const inclusions = [
      ...offer.copy.inclusions,
      offer.mileage.unlimited ? 'Unlimited mileage' : `${offer.mileage.quantity}${offer.mileage.unit}/${offer.mileage.period} rental mileage limit`,
    ]

    inclusions.sort((inclusion) => {
      if (inclusion.toLowerCase().includes('additional driver')) return -2
      if (inclusion.toLowerCase().includes('fee')) return -1
      return 0
    })

    return inclusions.slice(0, 3)
  }, [offer])

  return <VerticalSpacer gap={4}>
    {inclusionsList.length > 0 && <>
      <BodyText variant="medium" weight="bold">Free inclusions:</BodyText>
      {inclusionsList.map((inclusion) =>
        <Group direction="horizontal" gap={8} verticalAlign="center" key={inclusion}>
          <LineCheckIcon />
          <BodyText variant="medium">{inclusion}</BodyText>
        </Group>,
      )}
    </>}
    <TextLink size="medium" onClick={onViewInclusions}>View all inclusions & details</TextLink>
  </VerticalSpacer>
}

export default CarHireOfferTileInclusions
